<template>
  <div>
    <Modal v-model="modal" :width="520">
      <div slot="header" class="phrases-header">
        <span class="phrases-header-title">
          {{ $t(`approval.phrases.${editing ? 'edit' : 'title'}`) }}
        </span>
        <a
          class="phrases-btn"
          v-if="data.length > 0 && !editing"
          @click="onEdit()"
        >
          <Icon type="md-create" />
          {{ $t('btn.edit') }}
        </a>
        <a
          class="phrases-btn"
          v-if="editing && data.length < 10"
          @click="onAdd()"
        >
          <Icon type="md-add" />
          {{ $t('btn.add') }}
        </a>
      </div>

      <div style="min-height: 300px">
        <Spin fix v-if="loading" size="small"></Spin>
        <!--      无数据-->
        <div class="no-data" v-if="!loading && data.length === 0">
          <img
            style="width: 180px"
            src="@/assets/img/no-data.png"
            alt="no-data"
          />
          <Row type="flex" class="b-10">
            {{ $t('i.table.noDataText') }}
            <a class="add" @click="onAdd()">
              <Icon type="md-add" />
              {{ $t('btn.add') }}
            </a>
          </Row>
        </div>

        <!-- 列表-->
        <div class="phrases-container" v-if="!loading && data.length > 0">
          <template v-if="!editing">
            <div
              v-for="(v, i) in data"
              :key="'commonPhrases' + i"
              class="phrases-item phrases-item-hover"
              @click="onChange(i)"
            >
              <div :class="['phrases-item-txt']" v-html="v"></div>
              <div class="phrases-item-action">
                <Radio :value="selected === i"></Radio>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-for="(v, i) in data"
              :key="'commonPhrases' + i"
              class="phrases-item"
            >
              <div :class="['phrases-input']">
                <Input
                  :value="getPreviewVal(v)"
                  :maxlength="200"
                  show-word-limit
                  type="textarea"
                  @on-change="onInput($event, i)"
                  :placeholder="$t('approval.phrases.placeholder')"
                />
              </div>
              <div class="phrases-delete" @click="onDelete(i)">
                <Icon type="ios-trash-outline" :size="18" color="#cb272d" />
              </div>
            </div>
          </template>
        </div>
      </div>

      <div slot="footer">
        <Button type="text" @click="onCancel">{{ $t('btn.cancel') }}</Button>
        <Button type="primary" @click="onConfirm">{{ $t('btn.done') }}</Button>
      </div>
    </Modal>

    <div class="phrases-open">
      <div class="phrases-open-btn">
        <Icon type="ios-chatbubbles-outline" :size="16" color="#272E3B" />
        <span @click="onOpen">{{ $t('approval.phrases.add') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonPhrasesModal',
  data() {
    return {
      modal: false,
      editing: false,
      sbLoading: false,
      loading: false,
      selected: null,
      data: []
    };
  },
  methods: {
    onOpen() {
      this.modal = true;
      this.editing = false;
      this.initData();
    },
    onInput(e, index) {
      this.data[index] = e.target.value
        .replace(/\r{0,}\n/g, '<br/>')
        .replace(/\s/g, '&nbsp;');
    },
    async initData() {
      try {
        this.loading = true;
        const { data } = await this.$http(
          'get',
          `manager/approval_common_phrases`,
          {},
          true
        );
        this.data = data;
      } finally {
        this.loading = false;
      }
    },

    async onSubmit() {
      try {
        let form = _.filter(this.data, (v) => {
          return v;
        });
        this.sbLoading = true;
        await this.$http('post', `manager/approval_common_phrases`, form, true);
        await this.initData();
        this.editing = false;
        setTimeout(() => {
          this.$Message.success(this.$t('apply.success'));
        }, 1000);
      } finally {
        this.sbLoading = false;
      }
    },

    onEdit() {
      this.editing = !this.editing;
    },

    onDelete(index) {
      _.remove(this.data, (_v, i) => {
        return i === index;
      });
      this.data = [...this.data];
    },

    onAdd() {
      this.data.push('');
      this.editing = true;
    },

    onCancel() {
      if (this.editing) {
        this.editing = false;
        this.data = _.filter(this.data, (v) => {
          return v;
        });
      } else {
        this.modal = false;
      }
    },

    onConfirm() {
      if (this.editing) {
        this.onSubmit();
      } else {
        this.$emit('onChange', this.data[this.selected]);
        this.modal = false;
      }
      console.log(this.modal, 'this.modal');
    },

    getPreviewVal(v) {
      return v
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\&nbsp;/g, ' ')
        .replace(/<.*?>/g, '');
    },

    onChange(index) {
      this.selected = index;
    }
  }
};
</script>

<style scoped lang="less">
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  .add {
    display: flex;
    align-items: center;
    margin-left: 6px;
  }
}

.phrases {
  &-header {
    display: flex;
    align-items: center;
    gap: 8px;
    &-title {
      font-size: 15px;
      font-weight: 500;
    }
  }

  &-container {
    min-height: 300px;
  }

  &-btn {
    display: flex;
    font-size: 14px;
  }

  &-delete {
    cursor: pointer;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
  }

  &-delete:hover {
    background-color: #f7f8fa;
  }

  &-open {
    margin-top: 6px;
    display: flex;
    justify-content: flex-end;

    &-btn {
      display: flex;
      gap: 4px;
      padding: 0 6px;
      align-items: center;
      cursor: pointer;
      border-radius: 4px;
    }

    &-btn:hover {
      font-weight: 500;
      background-color: #f7f8fa;
    }
  }

  &-item-hover:hover {
    background-color: #e8f6ff;
    cursor: pointer;
  }

  &-input {
    flex: 1;
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 12px;
    justify-content: space-between;
    gap: 8px;
    border-bottom: 1px solid #f2f3f5;

    &-txt {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      word-break: break-all;
    }
  }
}
</style>
